var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _path, _path2, _circle, _circle2, _rect10, _rect11, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxRate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.3346,
    y: 1.83056,
    width: 36.386,
    height: 47.7008,
    transform: "rotate(14.6475 42.3346 1.83056)",
    fill: "#CCE5FF",
    stroke: "#027BC7",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.125,
    y: 20.6763,
    width: 29.305,
    height: 21.5478,
    transform: "rotate(14.65 41.125 20.6763)",
    fill: "#019EF7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42.6443,
    y: 22.8555,
    width: 7.07362,
    height: 4.30956,
    transform: "rotate(14.65 42.6443 22.8555)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40.9578,
    y: 29.3064,
    width: 7.07362,
    height: 4.30956,
    transform: "rotate(14.65 40.9578 29.3064)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 51.4431,
    y: 25.1555,
    width: 7.07362,
    height: 4.30956,
    transform: "rotate(14.65 51.4431 25.1555)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 49.7566,
    y: 31.6064,
    width: 7.07362,
    height: 4.30956,
    transform: "rotate(14.65 49.7566 31.6064)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 48.071,
    y: 38.0576,
    width: 7.07362,
    height: 4.30956,
    transform: "rotate(14.65 48.071 38.0576)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 39.2715,
    y: 35.7576,
    width: 7.07362,
    height: 4.30956,
    transform: "rotate(14.65 39.2715 35.7576)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 60.2429,
    y: 27.4558,
    width: 7.07362,
    height: 4.30956,
    transform: "rotate(14.65 60.2429 27.4558)",
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 58.5554,
    y: 33.9065,
    width: 7.07362,
    height: 4.30956,
    transform: "rotate(14.65 58.5554 33.9065)",
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8699,
    y: 40.3579,
    width: 7.07362,
    height: 4.30956,
    transform: "rotate(14.65 56.8699 40.3579)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7694 11.5342L12.9287 38.2534L15.9454 41.2701L31.0288 29.6343L35.7694 11.5342Z",
    fill: "#019EF7",
    stroke: "#FFFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5102 44.7178L12.498 25.3248L15.9457 22.3081L59.0412 44.7178H40.5102Z",
    fill: "#019EF7",
    stroke: "#FFFEFE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.61911,
    cy: 44.7177,
    r: 7.11911,
    stroke: "#019EF7",
    strokeWidth: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.61911,
    cy: 18.8603,
    r: 7.11911,
    stroke: "#019EF7",
    strokeWidth: 3,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 43.1377,
    y: 13.689,
    width: 29.3421,
    height: 3.57419,
    transform: "rotate(14.65 43.1377 13.689)",
    fill: "#019EF7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 44.8616,
    y: 6.7937,
    width: 29.3421,
    height: 3.57419,
    transform: "rotate(14.65 44.8616 6.7937)",
    fill: "#019EF7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.4267,
    cy: 30.4962,
    r: 1.29287,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxRate);
export default __webpack_public_path__ + "static/media/taxRate.4e68cb1a028a2ed4eb8ba745a0589766.svg";
export { ForwardRef as ReactComponent };